import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=a143b7dc"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=a143b7dc&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a143b7dc')) {
      api.createRecord('a143b7dc', component.options)
    } else {
      api.reload('a143b7dc', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=a143b7dc", function () {
      api.rerender('a143b7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/Transactions/components/DataForm.vue"
export default component.exports